import React from 'react'

const CategoryGrid = () => {
  const categories = [
    {
      svg: "Medical & Health Care SVG", // From original: profession.html line 85-89
      title: "Medical & Health Care"
    },
    {
      svg: "Development & Programming SVG", // From original: profession.html line 91-97
      title: "Development & Programming"
    },
    {
      svg: "Marketing & Sales SVG", // From original: profession.html line 99-111
      title: "Marketing & Sales"
    },
    {
      svg: "Business Management SVG", // From original: profession.html line 113-124
      title: "Business Management"
    },
    {
      svg: "Lawyer SVG", // From original: profession.html line 126-141
      title: "Lawyer"
    },
    {
      svg: "Teacher SVG", // From original: profession.html line 143-156
      title: "Teacher"
    },
    {
      svg: "Engineer SVG", // From original: profession.html line 158-168 (Base64 image)
      title: "Engineer"
    },
    {
      svg: "Plumber SVG", // From original: profession.html line 170-180 (Base64 image)
      title: "Plumber"
    },
    {
      svg: "Designer SVG", // From original: profession.html line 182-192 (Base64 image)
      title: "Designer"
    }
  ]

  return (
    <section className="categories">
      <div className="container">
        <h2>Build Resumes for Every Profession</h2>
        <p>Choose your Category and start Building today</p>

        <div className="category-list">
          {categories.map((category, index) => (
            <div className="category-item" key={index}>
              <div className="category-svg-placeholder">
                {/* SVG would be inserted here */}
                <span className="placeholder-text">{category.title.split(' ')[0]}</span>
              </div>
              <h4 dangerouslySetInnerHTML={{ __html: category.title.replace(' & ', '<br>') }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CategoryGrid